<template>
	<div class="ticket-info-container">
		<mobile-card :showFooter="showFooter">
			<template v-slot:title>
				<div>{{ ticketInfo }}</div>
			</template>
			<template v-slot:content>
				<div class="flex-form-info">
					<van-radio-group
						v-model="ticketType"
						icon-size="0.43rem"
						direction="horizontal"
						@change="handleTicketTypeChange">
						<van-radio name="1" checked-color="#005423">{{ ticketPersonText }}</van-radio>
						<van-radio name="2" checked-color="#005423" v-if="enableUseCompanyTitle">{{ ticketCompanyText }}</van-radio>
					</van-radio-group>
				</div>

				<van-field
					v-if="showPerson"
					v-model="detail.userName"
					clearable
					:label="ticketTitleNameText"
					label-align="left"
					:placeholder="ticketTitleNamePlaceholderText"
					required></van-field>

				<div v-if="showCompany" style="border-bottom: 1px solid #ebedf0">
					<div class="flex-form-info">
						<span>{{ ticketTitleNameText }}：</span>
						<span>{{ detail.name }}</span>
					</div>
					<div class="flex-form-info">
						<span>{{ ticketTaxNumberText }}：</span>
						<span>{{ detail.taxNumber }}</span>
					</div>
					<div class="flex-form-info" v-if="!showDetail">
						<span class="link" style="display: block; font-size: 12px" @click.prevent="showDetail = true">
							{{ ticketDetailViewText }}
						</span>
					</div>
					<div class="flex-form-info" v-if="showDetail">
						<span>{{ ticketCampanyAddressText }}：</span>
						<span>{{ detail.address }}</span>
					</div>
					<div class="flex-form-info" v-if="showDetail">
						<span>{{ ticketCampanyTelText }}：</span>
						<span>{{ detail.tele }}</span>
					</div>
					<div class="flex-form-info" v-if="showDetail">
						<span>{{ ticketCampanyBankNameText }}：</span>
						<span>{{ detail.depositBank }}</span>
					</div>
					<div class="flex-form-info" v-if="showDetail">
						<span>{{ ticketCampanyBankNumText }}：</span>
						<span>{{ detail.bank }}</span>
					</div>
					<div class="flex-form-info" v-if="showDetail">
						<span class="link" style="display: block; font-size: 12px" @click.prevent="showDetail = false">
							{{ ticketDetailFoldText }}
						</span>
					</div>
				</div>

				<div class="flex-form-info" style="margin-top: 10px" v-if="!showRemark">
					<div class="left link" style="line-height: 28px" @click.prevent="showRemark = !showRemark">
						{{ ticketRemarkText }}
					</div>
				</div>
				<div class="flex-form-info" v-if="showRemark">
					<div class="left link" style="line-height: 28px" @click.prevent="showRemark = !showRemark">
						{{ collapseTicketRemarkText }}：
					</div>
				</div>
				<div class="flex-form-info" style="height: auto" v-if="showRemark">
					<div style="width: 100%">
						<van-field
							input-align="left"
							label-align="right"
							size="14px"
							class="text-field"
							style="padding: 0px; margin: 0px; padding-right: 5px; text-align: right"
							v-model="remark"
							rows="2"
							autosize
							type="textarea"
							:maxlength="remarkLimit"
							show-word-limit
							:placeholder="ticketRemarkText" />
					</div>
				</div>
			</template>

			<template v-slot:footer>
				<div class="flex-form-footer">
					<mobile-button color="#005423" class="btn-font" @click="search">
						<van-icon name="search" />
						<span>{{ searchText }}</span>
					</mobile-button>
					<mobile-button color="#005423" class="btn-font" @click="addNew">
						<van-icon name="plus" />
						<span>{{ addText }}</span>
					</mobile-button>
				</div>
			</template>
		</mobile-card>
	</div>
</template>
<script>
import mobileCard from '@/components/mobile-card/index'
import MobileButton from 'components/mobile-button/index'
import { loadUserInfo } from '@/utils/cache'

export default {
	name: 'ticketInfo',
	props: {
		detail: Object,
		remarkLimit: Number
	},
	components: {
		MobileButton,
		mobileCard
	},

	computed: {
		showFooter() {
			return this.ticketType === '2'
		}
	},
	data() {
		return {
			ticketInfo: this.$t('pay_ticket.ticket_info'),
			ticketPersonText: this.$t('pay_ticket.person_title'),
			ticketCompanyText: this.$t('pay_ticket.company_title'),
			ticketTitleNameText: this.$t('pay_ticket.name'),
			ticketTitleNamePlaceholderText: this.$t('pay_ticket.name_placeholder'),
			ticketTaxNumberText: this.$t('pay_ticket.organ_model.taxNumber'),
			ticketRemarkText: this.$t('pay_ticket.ticket_remark'),
			ticketDetailViewText: this.$t('pay_ticket.organ_model.view_detail'),
			ticketCampanyAddressText: this.$t('pay_ticket.organ_model.address'),
			ticketCampanyTelText: this.$t('pay_ticket.organ_model.tele'),
			ticketCampanyBankNameText: this.$t('pay_ticket.organ_model.depositBank'),
			ticketCampanyBankNumText: this.$t('pay_ticket.organ_model.bank'),
			ticketDetailFoldText: this.$t('pay_ticket.organ_model.fold_detail'),
			collapseTicketRemarkText: this.$t('pay_ticket.collapse_ticket_remark'),
			searchText: this.$t('pay_ticket.search'),
			addText: this.$t('pay_ticket.add'),
			enableUseCompanyTitle: false,
			ticketType: '1',
			organ: {},
			showRemark: false,
			remark: '',
			showPerson: true,
			showCompany: false,
			showDetail: false
			//detail:{},
		}
	},

	methods: {
		addNew() {
			this.$emit('add-organ')
		},

		search() {
			this.$emit('search-organ')
		},

		getTicketTitleAndTaxNum() {
			let title = ''
			if (this.ticketType === '1') {
				title = this.detail.userName
			} else if (this.ticketType === '2') {
				title = this.detail.name
			} else {
				title = ''
			}
			return {
				title: title,
				taxNumber: this.detail.taxNumber,
				depositBank: this.detail.depositBank,
				tele: this.detail.tele,
				bank: this.detail.bank,
				address: this.detail.address,
				remark: this.remark
			}
		},

		handleTicketTypeChange(val) {
			console.log('val------', val)
			if (val == '1') {
				this.showPerson = true
				this.showCompany = false
			} else if (val == '2') {
				this.showPerson = false
				this.showCompany = true
			} else {
				this.showPerson = true
				this.showCompany = false
			}
			this.$emit('change-type', val)
		},

		updateTicketInfo(detail, enableUseCompanyTitle) {
			this.enableUseCompanyTitle = enableUseCompanyTitle
			this.detail = detail
			this.ticketType = detail.ticketType
		}
	}
}
</script>
<style lang="scss" scoped></style>
